import { render } from "./Errors.vue?vue&type=template&id=ca0db8e0&scoped=true"
import script from "./Errors.vue?vue&type=script&setup=true&lang=js"
export * from "./Errors.vue?vue&type=script&setup=true&lang=js"

import "./Errors.vue?vue&type=style&index=0&id=ca0db8e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca0db8e0"],['__file',"src/components/tools/components/Errors.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca0db8e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca0db8e0', __exports__)) {
    api.reload('ca0db8e0', __exports__)
  }
  
  module.hot.accept("./Errors.vue?vue&type=template&id=ca0db8e0&scoped=true", () => {
    api.rerender('ca0db8e0', render)
  })

}


export default __exports__